import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ standalone: true, name: 'emptyValue' })
export class EmptyValuePipe implements PipeTransform {
  transform(value?: unknown): string {
    if (value === null || value === undefined) {
      return '-';
    }

    if (typeof value === 'string') {
      const trimmed = value.trim();
      return trimmed.length > 0 ? trimmed : '-';
    }

    if (typeof value === 'number' || typeof value === 'bigint') {
      return String(value);
    }

    if (typeof value === 'boolean') {
      return value ? 'true' : 'false';
    }

    if (value instanceof Date) {
      return Number.isNaN(value.getTime()) ? '-' : value.toLocaleString();
    }

    if (Array.isArray(value)) {
      const parts = value
        .map((entry: unknown) => {
          if (typeof entry === 'string') return entry.trim();
          if (typeof entry === 'number' || typeof entry === 'bigint') return String(entry);
          if (typeof entry === 'boolean') return entry ? 'true' : 'false';
          return '';
        })
        .filter((s: string) => s.length > 0);

      return parts.length > 0 ? parts.join(', ') : '-';
    }

    return '-';
  }
}
